import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../../components/cta/cta";
import GatsbyLink from "../link/link";

export const CapabilityBase = styled.div`
  display: grid;
  gap: ${theme.spacing["8"]};
  margin-bottom: ${theme.spacing["4"]};
  padding: ${theme.spacing["8"]};
  background-color: ${theme.colors.blues[10]};
  border-radius: ${theme.borderRadius};

  ${theme.largerThan.md} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const ImageContainer = styled.div`
  border-radius: ${theme.borderRadius};
  overflow: hidden;

  ${theme.largerThan.md} {
    grid-column: span 1 / span 1;
  }
`;

export const Image = styled.img`
  object-fit: contain;
  width: 50%;
  height: 50%;

  ${theme.largerThan.md} {
    width: 100%;
    height: 100%;
  }
`;

export const TextContainer = styled.div`
  ${theme.largerThan.md} {
    grid-column: span 2 / span 2;
  }
`;

export const CapabilityTitle = styled.h4`
  margin-top: 0;
  grid-column: 3 / 7;
  grid-row: 1 / 2;
`;

export const CapabilitySubtitle = styled.div`
  font-size: ${theme.fontSizes[2]};
  line-height: ${theme.leading.normal};
  color: ${theme.colors.darkBlues[75]};
  margin-bottom: 24px;
  ${theme.largerThan.md} {
    margin-bottom: 40px;
    grid-column: 3 / 7;
    grid-row: 2 / 3;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing[8]};
`;

export const StyledCTA = styled(CTA)``;

export const StyledLink = styled(GatsbyLink)`
  align-self: center;

  ${theme.largerThan.md} {
  }
`;
